(function () {
  'use strict';


  /* =========================================================
     DOM READY
  ========================================================= */

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }


  function each(selector, callback) {
    var items = document.querySelectorAll(selector);

    for (var i = 0; i < items.length; i += 1) {
      callback(items[i], i);
    }
  }



  /* =========================================================
     PRODUCT GALLERY
     CLICK + MOBILE SWIPE + DESKTOP DRAG
  ========================================================= */

  window.alpSetImage = function (
    src,
    alt,
    thumb
  ) {

    var image =
      document.getElementById(
        'alpMainImgEl'
      );


    if (!image || !src) {
      return;
    }


    image.src = src;

    image.alt =
      alt ||
      image.alt ||
      '';


    each(
      '.alp-thumb',
      function (item) {

        item.classList.remove(
          'alp-active'
        );

        item.removeAttribute(
          'aria-current'
        );

      }
    );


    if (thumb) {

      thumb.classList.add(
        'alp-active'
      );

      thumb.setAttribute(
        'aria-current',
        'true'
      );

    }

  };



  function initProductGallerySwipe() {

    var gallery =
      document.querySelector(
        '[data-alp-gallery]'
      ) ||
      document.querySelector(
        '.alp-gallery'
      );


    if (!gallery) {
      return;
    }


    var galleryMain =
      gallery.querySelector(
        '[data-alp-gallery-main]'
      ) ||
      gallery.querySelector(
        '.alp-gallery-main'
      );


    var mainImage =
      gallery.querySelector(
        '#alpMainImgEl'
      );


    var thumbs =
      Array.prototype.slice.call(
        gallery.querySelectorAll(
          '[data-alp-thumb], .alp-thumb'
        )
      );


    if (
      !galleryMain ||
      !mainImage ||
      !thumbs.length
    ) {
      return;
    }


    var startX = 0;
    var startY = 0;

    var pointerDown = false;
    var activePointerId = null;


    galleryMain.style.touchAction =
      'pan-y';

    galleryMain.style.userSelect =
      'none';

    galleryMain.style.webkitUserSelect =
      'none';

    galleryMain.style.cursor =
      thumbs.length > 1
        ? 'grab'
        : 'default';


    mainImage.setAttribute(
      'draggable',
      'false'
    );


    mainImage.addEventListener(
      'dragstart',
      function (event) {
        event.preventDefault();
      }
    );



    function getThumbData(thumb) {

      var src =
        thumb.getAttribute(
          'data-image-src'
        );


      var alt =
        thumb.getAttribute(
          'data-image-alt'
        ) || '';


      if (!src) {

        var thumbImage =
          thumb.querySelector(
            'img'
          );


        if (thumbImage) {

          src =
            thumbImage.currentSrc ||
            thumbImage.src;

          alt =
            thumbImage.alt ||
            alt;

        }

      }


      return {
        src: src,
        alt: alt
      };

    }



    function showThumb(
      thumb,
      shouldScroll
    ) {

      if (!thumb) {
        return;
      }


      var data =
        getThumbData(
          thumb
        );


      if (!data.src) {
        return;
      }


      window.alpSetImage(
        data.src,
        data.alt,
        thumb
      );


      if (
        shouldScroll !== false &&
        typeof thumb.scrollIntoView ===
          'function'
      ) {

        thumb.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });

      }

    }



    thumbs.forEach(
      function (thumb) {

        /*
          Remove dependency on any
          old inline onclick.
        */

        thumb.onclick = null;


        thumb.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            showThumb(
              thumb,
              true
            );

          }
        );

      }
    );



    function currentIndex() {

      for (
        var i = 0;
        i < thumbs.length;
        i += 1
      ) {

        if (
          thumbs[i]
            .classList
            .contains(
              'alp-active'
            )
        ) {

          return i;

        }

      }


      return 0;

    }



    function goTo(index) {

      if (
        thumbs.length < 2
      ) {
        return;
      }


      if (
        index >=
        thumbs.length
      ) {

        index = 0;

      }


      if (
        index < 0
      ) {

        index =
          thumbs.length - 1;

      }


      showThumb(
        thumbs[index],
        true
      );

    }



    galleryMain.addEventListener(
      'pointerdown',
      function (event) {

        if (
          thumbs.length < 2
        ) {
          return;
        }


        if (
          event.pointerType ===
            'mouse' &&
          event.button !== 0
        ) {
          return;
        }


        pointerDown = true;

        activePointerId =
          event.pointerId;

        startX =
          event.clientX;

        startY =
          event.clientY;


        if (
          event.pointerType ===
          'mouse'
        ) {

          galleryMain.style.cursor =
            'grabbing';

        }


        if (
          galleryMain
            .setPointerCapture
        ) {

          try {

            galleryMain
              .setPointerCapture(
                event.pointerId
              );

          } catch (error) {

            /* optional */

          }

        }

      }
    );



    galleryMain.addEventListener(
      'pointerup',
      function (event) {

        if (!pointerDown) {
          return;
        }


        if (
          activePointerId !== null &&
          event.pointerId !==
            activePointerId
        ) {
          return;
        }


        pointerDown = false;
        activePointerId = null;


        galleryMain.style.cursor =
          thumbs.length > 1
            ? 'grab'
            : 'default';


        var distanceX =
          event.clientX -
          startX;


        var distanceY =
          event.clientY -
          startY;


        /*
          Ignore normal taps.
        */

        if (
          Math.abs(
            distanceX
          ) < 40
        ) {
          return;
        }


        /*
          Allow vertical page scrolling.
        */

        if (
          Math.abs(
            distanceX
          ) <=
          Math.abs(
            distanceY
          )
        ) {
          return;
        }


        /*
          Swipe left = next
          Swipe right = previous
        */

        goTo(
          currentIndex() +
          (
            distanceX < 0
              ? 1
              : -1
          )
        );

      }
    );



    function resetPointer() {

      pointerDown = false;
      activePointerId = null;

      galleryMain.style.cursor =
        thumbs.length > 1
          ? 'grab'
          : 'default';

    }


    galleryMain.addEventListener(
      'pointercancel',
      resetPointer
    );


    galleryMain.addEventListener(
      'lostpointercapture',
      resetPointer
    );

  }



  /* =========================================================
     QUANTITY
  ========================================================= */

  window.alpQty = function (
    direction
  ) {

    var input =
      document.getElementById(
        'alpQtyInput'
      );


    if (!input) {
      return;
    }


    var value =
      parseInt(
        input.value,
        10
      );


    if (
      isNaN(value)
    ) {

      value = 1;

    }


    value += direction;


    if (
      value < 1
    ) {

      value = 1;

    }


    input.value =
      value;

  };



  /* =========================================================
     VARIANT SELECTION
  ========================================================= */

  window.alpSelectVariant =
    function (button) {


      if (!button) {
        return;
      }


      each(
        '.alp-variant-btn',
        function (item) {

          item.classList.remove(
            'alp-active'
          );

        }
      );


      button.classList.add(
        'alp-active'
      );


      var variantInput =
        document.getElementById(
          'alpVariantId'
        );


      var priceElement =
        document.getElementById(
          'alpPrice'
        );


      var compareElement =
        document.getElementById(
          'alpCompare'
        );


      var mainAddButton =
        document.getElementById(
          'alpAddToCart'
        );


      var stickyPrice =
        document.getElementById(
          'alpStickyPrice'
        );


      var stickyButton =
        document.getElementById(
          'alpStickyBtn'
        );


      var stickyCompare =
        document.getElementById(
          'alpStickyCompare'
        );


      var price =
        button.getAttribute(
          'data-price'
        ) || '';


      var compare =
        button.getAttribute(
          'data-compare'
        ) || '';


      var available =
        button.getAttribute(
          'data-available'
        ) === 'true';



      if (
        variantInput &&
        button.getAttribute(
          'data-variant-id'
        )
      ) {

        variantInput.value =
          button.getAttribute(
            'data-variant-id'
          );

      }



      if (
        priceElement &&
        price
      ) {

        priceElement.textContent =
          price;

      }



      if (
        stickyPrice &&
        price
      ) {

        stickyPrice.textContent =
          price;

      }



      if (compareElement) {

        if (compare) {

          compareElement.textContent =
            compare;

          compareElement.style.display =
            '';

        } else {

          compareElement.style.display =
            'none';

        }

      }



      if (stickyCompare) {

        if (compare) {

          stickyCompare.textContent =
            compare;

          stickyCompare.style.display =
            '';

        } else {

          stickyCompare.style.display =
            'none';

        }

      }



      if (mainAddButton) {

        mainAddButton.disabled =
          !available;

        mainAddButton.textContent =
          available
            ? 'Add to cart'
            : 'Sold out';

      }



      if (stickyButton) {

        stickyButton.disabled =
          !available;

        stickyButton.textContent =
          available
            ? 'Add to cart'
            : 'Sold out';

      }

    };



  /* =========================================================
     PRODUCT ACCORDION
  ========================================================= */

  window.alpToggle =
    function (button) {


      if (!button) {
        return;
      }


      var body =
        button
          .nextElementSibling;


      button.classList.toggle(
        'alp-open'
      );


      if (body) {

        body.classList.toggle(
          'alp-open'
        );

      }

    };



  /* =========================================================
     RESULTS / DERM SLIDER DOTS
  ========================================================= */

  function updateDots(
    dotsId,
    current
  ) {

    if (!dotsId) {
      return;
    }


    var dots =
      document.getElementById(
        dotsId
      );


    if (!dots) {
      return;
    }


    var dotItems =
      dots.querySelectorAll(
        '.als-slide-dot'
      );


    for (
      var i = 0;
      i < dotItems.length;
      i += 1
    ) {

      dotItems[i]
        .classList
        .toggle(
          'active',
          i === current
        );

    }

  }



  window.alsSlide =
    function (
      trackId,
      dotsId,
      direction
    ) {


      var track =
        document.getElementById(
          trackId
        );


      if (
        !track ||
        window.innerWidth > 900
      ) {
        return;
      }


      var slides =
        track.querySelectorAll(
          '.als-slide'
        );


      if (
        !slides.length
      ) {
        return;
      }


      var current =
        parseInt(
          track.getAttribute(
            'data-current'
          ) || '0',
          10
        );


      current =
        (
          current +
          direction +
          slides.length
        ) %
        slides.length;


      track.setAttribute(
        'data-current',
        String(current)
      );


      track.style.transform =
        'translateX(-' +
        (current * 100) +
        '%)';


      updateDots(
        dotsId,
        current
      );

    };



  window.alsGoTo =
    function (
      trackId,
      dotsId,
      index
    ) {


      var track =
        document.getElementById(
          trackId
        );


      if (
        !track ||
        window.innerWidth > 900
      ) {
        return;
      }


      track.setAttribute(
        'data-current',
        String(index)
      );


      track.style.transform =
        'translateX(-' +
        (index * 100) +
        '%)';


      updateDots(
        dotsId,
        index
      );

    };



  /* =========================================================
     HOW TO USE VIDEOS
  ========================================================= */

  window.alsPlayVideo =
    function (wrapper) {


      if (!wrapper) {
        return;
      }


      var video =
        wrapper.querySelector(
          'video'
        );


      if (!video) {
        return;
      }


      var videos =
        document.querySelectorAll(
          '.als-htu-video'
        );


      for (
        var i = 0;
        i < videos.length;
        i += 1
      ) {

        if (
          videos[i] !== video &&
          !videos[i].paused
        ) {

          videos[i].pause();


          var otherWrapper =
            videos[i]
              .parentNode;


          if (
            otherWrapper &&
            otherWrapper.classList
          ) {

            otherWrapper
              .classList
              .remove(
                'is-playing'
              );

          }

        }

      }



      if (video.paused) {

        var playPromise =
          video.play();


        wrapper
          .classList
          .add(
            'is-playing'
          );


        if (
          playPromise &&
          typeof
            playPromise.catch ===
            'function'
        ) {

          playPromise.catch(
            function () {

              wrapper
                .classList
                .remove(
                  'is-playing'
                );

            }
          );

        }

      } else {

        video.pause();

        wrapper
          .classList
          .remove(
            'is-playing'
          );

      }

    };



  /* =========================================================
     FAQ
  ========================================================= */

  window.alsFAQToggle =
    function (button) {


      if (!button) {
        return;
      }


      var answer =
        button
          .nextElementSibling;


      button.classList.toggle(
        'als-open'
      );


      if (answer) {

        answer.classList.toggle(
          'als-open'
        );

      }

    };



  /* =========================================================
     CART DRAWER HELPERS
     DESKTOP + MOBILE SAFE
  ========================================================= */

  function getCartDrawer() {

    return document.querySelector(
      'cart-drawer'
    );

  }



  function forceDrawerVisible(
    drawer,
    trigger
  ) {

    if (!drawer) {
      return false;
    }


    drawer.classList.remove(
      'is-empty'
    );


    /*
      Use native cart drawer open method.
    */

    if (
      typeof
        drawer.open ===
        'function'
    ) {

      try {

        drawer.open(
          trigger
        );

      } catch (error) {

        console.warn(
          'ALANNA cart drawer open fallback:',
          error
        );

      }

    }


    /*
      Extra mobile fallback.
    */

    drawer.classList.add(
      'animate',
      'active'
    );


    document.body.classList.add(
      'overflow-hidden'
    );


    return true;

  }



  function clickHeaderCartFallback() {

    var cartIcon =
      document.querySelector(
        '#cart-icon-bubble'
      );


    if (!cartIcon) {
      return false;
    }


    try {

      cartIcon.click();

      return true;

    } catch (error) {

      return false;

    }

  }



  /* =========================================================
     MANUAL DRAWER SECTION REFRESH
  ========================================================= */

  function manuallyRefreshDrawerSections(
    data
  ) {

    if (
      !data ||
      !data.sections
    ) {
      return;
    }



    var drawerHTML =
      data.sections[
        'cart-drawer'
      ];


    var iconHTML =
      data.sections[
        'cart-icon-bubble'
      ];



    /* CART DRAWER */

    if (drawerHTML) {

      var parsedDrawer =
        new DOMParser()
          .parseFromString(
            drawerHTML,
            'text/html'
          );


      var newCartDrawerContent =
        parsedDrawer
          .querySelector(
            '#CartDrawer'
          );


      var currentCartDrawerContent =
        document
          .querySelector(
            '#CartDrawer'
          );


      if (
        newCartDrawerContent &&
        currentCartDrawerContent
      ) {

        currentCartDrawerContent
          .innerHTML =
          newCartDrawerContent
            .innerHTML;

      }

    }



    /* CART ICON */

    if (iconHTML) {

      var parsedIcon =
        new DOMParser()
          .parseFromString(
            iconHTML,
            'text/html'
          );


      var newIcon =
        parsedIcon
          .querySelector(
            '#cart-icon-bubble'
          );


      var currentIcon =
        document
          .querySelector(
            '#cart-icon-bubble'
          );


      if (
        newIcon &&
        currentIcon
      ) {

        currentIcon.innerHTML =
          newIcon.innerHTML;

      }

    }

  }



  /* =========================================================
     REFRESH + OPEN CART DRAWER
  ========================================================= */

  function renderAndOpenCartDrawer(
    data,
    trigger
  ) {

    var opened = false;



    function tryRenderAndOpen() {

      var drawer =
        getCartDrawer();


      if (!drawer) {
        return false;
      }


      drawer.classList.remove(
        'is-empty'
      );


      /*
        Normal ALANNA / Dawn method.
      */

      if (
        typeof
          drawer.renderContents ===
          'function'
      ) {

        try {

          drawer.renderContents(
            data
          );

          opened = true;

        } catch (error) {

          console.warn(
            'ALANNA cart drawer render fallback:',
            error
          );


          manuallyRefreshDrawerSections(
            data
          );

        }

      } else {

        manuallyRefreshDrawerSections(
          data
        );

      }



      /*
        Open now.
      */

      forceDrawerVisible(
        drawer,
        trigger
      );



      /*
        Re-open after Shopify updates HTML.
      */

      window.setTimeout(
        function () {

          var currentDrawer =
            getCartDrawer();


          if (currentDrawer) {

            forceDrawerVisible(
              currentDrawer,
              trigger
            );

          }

        },
        80
      );



      /*
        Strong mobile fallback.
      */

      window.setTimeout(
        function () {

          var currentDrawer =
            getCartDrawer();


          if (
            currentDrawer &&
            !currentDrawer
              .classList
              .contains(
                'active'
              )
          ) {

            forceDrawerVisible(
              currentDrawer,
              trigger
            );

          }

        },
        300
      );


      return true;

    }



    /*
      First attempt.
    */

    if (
      tryRenderAndOpen()
    ) {
      return;
    }



    /*
      cart-drawer.js can be deferred.

      Wait for Shopify to register
      the cart-drawer web component.
    */

    if (
      window.customElements &&
      typeof
        window.customElements
          .whenDefined ===
          'function'
    ) {

      window.customElements
        .whenDefined(
          'cart-drawer'
        )
        .then(
          function () {

            if (
              !tryRenderAndOpen()
            ) {

              clickHeaderCartFallback();

            }

          }
        );

    }



    /*
      Final fallback.
    */

    window.setTimeout(
      function () {

        var drawer =
          getCartDrawer();


        if (drawer) {

          if (!opened) {

            manuallyRefreshDrawerSections(
              data
            );

          }


          forceDrawerVisible(
            drawer,
            trigger
          );

        } else {

          clickHeaderCartFallback();

        }

      },
      700
    );

  }



  /* =========================================================
     PRODUCT PAGE ADD TO CART
     AJAX + DRAWER OPEN
  ========================================================= */

  function initProductPageCart() {

    var form =
      document.getElementById(
        'alpProductForm'
      );


    var mainButton =
      document.getElementById(
        'alpAddToCart'
      );


    if (
      !form ||
      !mainButton
    ) {
      return;
    }


    /*
      Prevent duplicate listeners.
    */

    if (
      form.getAttribute(
        'data-alanna-cart-ready'
      ) === 'true'
    ) {
      return;
    }


    form.setAttribute(
      'data-alanna-cart-ready',
      'true'
    );



    form.addEventListener(
      'submit',
      function (event) {

        event.preventDefault();


        var submitButton =
          event.submitter ||
          mainButton;


        if (
          !submitButton ||
          submitButton.disabled
        ) {
          return;
        }


        if (
          submitButton.getAttribute(
            'data-alanna-loading'
          ) === 'true'
        ) {
          return;
        }



        var originalText =

          submitButton.textContent &&
          submitButton.textContent.trim()

            ? submitButton
                .textContent
                .trim()

            : 'Add to cart';



        submitButton.setAttribute(
          'data-alanna-loading',
          'true'
        );


        submitButton.disabled =
          true;


        submitButton.textContent =
          'Adding...';



        /* =========================================
           BUILD SHOPIFY REQUEST
        ========================================= */

        var formData =
          new FormData(
            form
          );


        formData.set(
          'sections',
          'cart-drawer,cart-icon-bubble'
        );


        formData.set(
          'sections_url',
          window.location.pathname
        );



        var addUrl =

          window.routes &&
          window.routes.cart_add_url

            ? window.routes
                .cart_add_url

            : '/cart/add.js';



        /* =========================================
           ADD PRODUCT
        ========================================= */

        fetch(
          addUrl,
          {

            method:
              'POST',

            headers: {

              'X-Requested-With':
                'XMLHttpRequest',

              'Accept':
                'application/json'

            },

            body:
              formData

          }
        )


        .then(
          function (response) {

            return response
              .json()
              .then(
                function (data) {


                  if (
                    !response.ok ||
                    data.status
                  ) {

                    throw new Error(

                      data.description ||

                      data.message ||

                      'Unable to add this product to the cart.'

                    );

                  }


                  return data;

                }
              );

          }
        )


        .then(
          function (data) {


            /* SUCCESS */

            submitButton.textContent =
              'Added!';



            /*
              Update and open drawer.
            */

            renderAndOpenCartDrawer(
              data,
              submitButton
            );



            /*
              Reset button.
            */

            window.setTimeout(
              function () {

                submitButton.textContent =
                  originalText;


                submitButton.disabled =
                  false;


                submitButton.setAttribute(
                  'data-alanna-loading',
                  'false'
                );

              },
              1200
            );

          }
        )


        .catch(
          function (error) {


            console.error(
              'ALANNA product add-to-cart error:',
              error
            );


            submitButton.textContent =
              originalText;


            submitButton.disabled =
              false;


            submitButton.setAttribute(
              'data-alanna-loading',
              'false'
            );


            var cartError =
              document.querySelector(
                '#CartDrawer-CartErrors'
              );


            if (cartError) {

              cartError.textContent =

                error.message ||

                'Unable to add this product. Please try again.';

            } else {

              alert(

                error.message ||

                'Unable to add this product. Please try again.'

              );

            }

          }
        );

      }
    );

  }



  /* =========================================================
     STICKY ADD TO CART
     MOBILE SAFE
  ========================================================= */

  function initStickyCart() {

    var form =
      document.getElementById(
        'alpProductForm'
      );


    var mainButton =
      document.getElementById(
        'alpAddToCart'
      );


    var stickyCart =
      document.getElementById(
        'alpStickyAtc'
      );


    var stickyButton =
      document.getElementById(
        'alpStickyBtn'
      );


    if (
      !form ||
      !mainButton ||
      !stickyCart ||
      !stickyButton
    ) {
      return;
    }



    /* =========================================
       SHOW / HIDE STICKY BAR
    ========================================= */

    if (
      'IntersectionObserver'
      in window
    ) {

      var observer =
        new IntersectionObserver(
          function (entries) {

            var entry =
              entries[0];


            if (!entry) {
              return;
            }


            stickyCart
              .classList
              .toggle(

                'is-visible',

                !entry.isIntersecting

              );

          },
          {
            threshold:
              0.1
          }
        );


      observer.observe(
        mainButton
      );

    } else {

      window.addEventListener(
        'scroll',
        function () {

          var rect =
            mainButton
              .getBoundingClientRect();


          stickyCart
            .classList
            .toggle(

              'is-visible',

              rect.bottom < 0

            );

        }
      );

    }



    /* =========================================
       STICKY BUTTON
       MOBILE SAFE
    ========================================= */

    stickyButton
      .addEventListener(
        'click',
        function (event) {

          event.preventDefault();


          if (
            stickyButton.disabled ||
            mainButton.disabled
          ) {
            return;
          }


          /*
            Use the real Add to Cart
            button so the exact same
            form submit handler is used.
          */

          mainButton.click();

        }
      );

  }



  /* =========================================================
     MOBILE RESULT / DERM SLIDERS
  ========================================================= */

  function initMobileSliders() {

    var wrappers =
      document.querySelectorAll(
        '.als-slider-wrap'
      );


    for (
      var i = 0;
      i < wrappers.length;
      i += 1
    ) {

      (function (wrapper) {

        var track =
          wrapper.querySelector(
            '.als-slider-track'
          );


        var startX = 0;


        if (!track) {
          return;
        }


        wrapper.addEventListener(
          'touchstart',
          function (event) {

            if (
              window.innerWidth > 900 ||
              !event.changedTouches.length
            ) {
              return;
            }


            startX =
              event
                .changedTouches[0]
                .screenX;

          },
          false
        );


        wrapper.addEventListener(
          'touchend',
          function (event) {

            if (
              window.innerWidth > 900 ||
              !event.changedTouches.length
            ) {
              return;
            }


            var endX =
              event
                .changedTouches[0]
                .screenX;


            var distance =
              endX -
              startX;


            if (
              Math.abs(
                distance
              ) < 40
            ) {
              return;
            }


            var wrapperId =
              wrapper.id ||
              '';


            var dotsId =
              '';


            if (
              wrapperId.indexOf(
                'alsBASlider-'
              ) === 0
            ) {

              dotsId =
                wrapperId.replace(

                  'alsBASlider-',

                  'alsBADots-'

                );

            } else if (
              wrapperId.indexOf(
                'alsDermSlider-'
              ) === 0
            ) {

              dotsId =
                wrapperId.replace(

                  'alsDermSlider-',

                  'alsDermDots-'

                );

            }


            window.alsSlide(

              track.id,

              dotsId,

              distance < 0
                ? 1
                : -1

            );

          },
          false
        );

      }(
        wrappers[i]
      ));

    }



    window.addEventListener(
      'resize',
      function () {

        if (
          window.innerWidth <=
          900
        ) {
          return;
        }


        var tracks =
          document
            .querySelectorAll(
              '.als-slider-track'
            );


        for (
          var i = 0;
          i < tracks.length;
          i += 1
        ) {

          tracks[i]
            .style
            .transform =
            '';


          tracks[i]
            .setAttribute(
              'data-current',
              '0'
            );

        }


        var dots =
          document
            .querySelectorAll(
              '.als-slide-dots'
            );


        for (
          var j = 0;
          j < dots.length;
          j += 1
        ) {

          var dotItems =
            dots[j]
              .querySelectorAll(
                '.als-slide-dot'
              );


          for (
            var k = 0;
            k < dotItems.length;
            k += 1
          ) {

            dotItems[k]
              .classList
              .toggle(
                'active',
                k === 0
              );

          }

        }

      }
    );

  }



  /* =========================================================
     LAZY LOAD LIVELY SCRIPTS
  ========================================================= */

  function loadExternalScript(
    marker
  ) {

    if (
      !marker ||
      marker.getAttribute(
        'data-loaded'
      ) === 'true'
    ) {
      return;
    }


    var src =
      marker.getAttribute(
        'data-src'
      );


    if (!src) {
      return;
    }


    var existing =
      document.querySelector(
        'script[src="' +
        src +
        '"]'
      );


    if (existing) {

      marker.setAttribute(
        'data-loaded',
        'true'
      );

      return;

    }


    var script =
      document.createElement(
        'script'
      );


    script.src =
      src;

    script.defer =
      true;


    if (
      marker.getAttribute(
        'data-type'
      )
    ) {

      script.type =
        marker.getAttribute(
          'data-type'
        );

    }


    marker.setAttribute(
      'data-loaded',
      'true'
    );


    document.head.appendChild(
      script
    );

  }



  function initLazyScripts() {

    var markers =
      document.querySelectorAll(
        '.alp-lazy-script[data-src]'
      );


    for (
      var i = 0;
      i < markers.length;
      i += 1
    ) {

      (function (marker) {

        var target =
          marker.parentNode ||
          marker;


        if (
          !(
            'IntersectionObserver'
            in window
          )
        ) {

          loadExternalScript(
            marker
          );

          return;

        }


        var observer =
          new IntersectionObserver(
            function (entries) {

              var entry =
                entries[0];


              if (
                entry &&
                entry.isIntersecting
              ) {

                loadExternalScript(
                  marker
                );


                observer.disconnect();

              }

            },
            {
              rootMargin:
                '600px 0px'
            }
          );


        observer.observe(
          target
        );

      }(
        markers[i]
      ));

    }

  }



  /* =========================================================
     INITIALISE EVERYTHING
  ========================================================= */

  onReady(
    function () {

      initProductGallerySwipe();

      initProductPageCart();

      initStickyCart();

      initMobileSliders();

      initLazyScripts();

    }
  );


}());